import { render, staticRenderFns } from "./departmentList.vue?vue&type=template&id=71ae1d7d&"
import script from "./departmentList.vue?vue&type=script&lang=js&"
export * from "./departmentList.vue?vue&type=script&lang=js&"
import style0 from "./departmentList.vue?vue&type=style&index=0&id=71ae1d7d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports